import { themeCssVars } from "@app/core";
import { useTheme } from "@app/ui";
import { useEffect } from "react";
import { useThemeStore } from "../../stores/theme.store.js";

/**
 * Writes the active theme's chrome colors onto `:root` as `H S% L%` CSS vars
 * (`--background`, `--card`, `--primary`, …) for the resolved light/dark mode.
 * Inline vars override the static defaults in `styles.css`; the `.dark` class
 * (toggled by ThemeProvider) still gates Tailwind `dark:` variants. Mount once,
 * high in the tree (inside ThemeProvider).
 */
export function ThemeStyleInjector(): null {
  const { resolved } = useTheme();
  const config = useThemeStore((s) => s.config);
  useEffect(() => {
    const root = document.documentElement;
    const vars = themeCssVars(config, resolved);
    for (const [name, value] of Object.entries(vars)) root.style.setProperty(name, value);
  }, [config, resolved]);
  return null;
}
